import { render, staticRenderFns } from "./OutpatientWarrant.vue?vue&type=template&id=6fc72c0a&scoped=true"
import script from "./OutpatientWarrant.vue?vue&type=script&lang=js"
export * from "./OutpatientWarrant.vue?vue&type=script&lang=js"
import style0 from "./OutpatientWarrant.vue?vue&type=style&index=0&id=6fc72c0a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fc72c0a",
  null
  
)

export default component.exports